import React, { useMemo } from 'react'
import AsyncSelect from 'react-select/async'
import { components as defaultComponents, ControlProps, CSSObjectWithLabel } from 'react-select'
import { Icon, colors } from 'common-components'
import { debounce } from '@helpers/debounce'

const customStyles = {
  control: (provided: CSSObjectWithLabel) => ({
    ...provided,
    display: 'flex',
    height: '40px',
    alignItems: 'center',
    gap: '8px',
    alignSelf: 'stretch',
    borderRadius: '8px',
    border: '1px solid #D0D5DD',
    background: '#FFF',
    boxShadow: '0px 1px 2px 0px rgba(16, 24, 40, 0.05)',
    ':hover': {
      borderColor: '#D0D5DD',
    },
  }),
  dropdownIndicator: () => ({}),
  indicatorSeparator: () => ({}),
}

const Control: React.FC<ControlProps<any, boolean>> = ({ children, ...props }) => {
  return (
    <defaultComponents.Control {...props}>
      <div style={{ paddingLeft: 5, marginTop: 5 }}>
        <Icon width={15} height={15} color={colors.gray500} icon='SearchSm' />
      </div>
      {children}
    </defaultComponents.Control>
  )
}

export type ValueSelectType = {
  value: string
  label: string
}
type SelectPropsType<T extends ValueSelectType> = {
  loadOptions: (inputValue: string, callback: (options: T[]) => void) => void
  value: T | ''
  valuesSelected?: string[]
  onChange: (value: T | '') => void
  disabled?: boolean
}

const SelectAsync = <T extends ValueSelectType>({
  loadOptions,
  value,
  valuesSelected = [],
  onChange,
  disabled,
}: SelectPropsType<T>) => {
  const debouncedLoadOptions = useMemo(() => debounce(loadOptions, 500), [loadOptions])

  return (
    <AsyncSelect
      cacheOptions
      defaultOptions
      loadOptions={debouncedLoadOptions}
      value={value}
      isClearable
      isSearchable
      isDisabled={disabled}
      onChange={onChange}
      menuPortalTarget={document.body}
      menuPosition='fixed'
      components={{
        Control,
        DropdownIndicator: () => null,
        IndicatorSeparator: () => null,
        ClearIndicator: (props) => (
          <defaultComponents.ClearIndicator {...props}>
            <Icon width={18} height={18} icon='XClose' />
          </defaultComponents.ClearIndicator>
        ),
        Option: ({ innerProps, innerRef, children }) => {
          const include = valuesSelected.includes(children?.toString())
          if (include) return null
          return (
            <div
              style={{
                padding: '10px',
              }}
              ref={innerRef}
              {...innerProps}
            >
              {children}
            </div>
          )
        },
      }}
      styles={{
        ...customStyles,
        menuPortal: (base) => ({
          ...base,
          zIndex: 9999,
        }),
      }}
    />
  )
}

export default SelectAsync
